export default "__VITE_ASSET__190324c3__"